// Estados de Campañas RECOGIDAS:
export const MCampanyaEstadosList: any[] = [
    // 1 Pendiente, 2 Parcialmente Asignada, 3 Asignada, 4 En proceso, 6 Completada, 8 Incidencia
    { id: 1, nombre: 'Pendiente' },
    { id: 2, nombre: 'Parcialmente Asignada' },
    { id: 3, nombre: 'Asignada' },
    { id: 4, nombre: 'En proceso' },
    { id: 6, nombre: 'Completada' },
    { id: 8, nombre: 'Incidencia' },
];

// Estados de Campañas PREPARACIÓN:
export const MCampanyaPreparacionEstadosList: any[] = [
    // PREPARACIÓN 1 pendiente, 2 En Proceso, 3- Finalizada, 8 error
    { id: 1, nombre: 'Pendiente' },
    { id: 2, nombre: 'En Proceso' },
    { id: 3, nombre: 'Finalizada' },
    { id: 9, nombre: 'Error' },
];


// Estados de Pedidos Externos: 
export const MPedidosExternosEstadosList: any[] = [
    //1=articulos NO válidos / 2=Pendiente / 3=Cargado / 4 Eliminado
    { id: 1, nombre: 'Artículos NO válidos' },
    { id: 2, nombre: 'Pendiente' },
    { id: 3, nombre: 'Cargado' },
    { id: 4, nombre: 'Eliminado' }
];

export const MPedidosEstadosList: any[] = [
    // 1 Pendiente, 2 en proceso, 3 Servido, 4 Cancelado, 5 Servido parcialmente, 8 Incidencia
    { valor: '0', nombre: 'Todos los estados', cantidad: 0 },
    { valor: '1', nombre: 'Pendientes', cantidad: 0 },
    { valor: '2', nombre: 'En proceso', cantidad: 0 },
    { valor: '3', nombre: 'Servidos', cantidad: 0 },
    { valor: '4', nombre: 'Cancelados', cantidad: 0 },
    { valor: '5', nombre: 'Servidos con faltas', cantidad: 0 },
    { valor: '8', nombre: 'Incidencias', cantidad: 0 },
];
